import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import * as FileSaver from "file-saver";

import { NotificationsService } from "./../../../shared/services/notifications.service";
import { UserService } from "./../../../shared/services/user.service";
import { ViewStateService } from "./../../../shared/services/view-state.service";
import { PractitionerService } from "./../../shared/services/practitioner.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-certificates-view",
  templateUrl: "./certificates-view.component.html",
})
export class CertificateViewComponent implements OnInit, OnDestroy {
  personId: any;
  documents: Array<object>;
  private destroy$ = new Subject<void>();

  constructor(
    private notifications: NotificationsService,
    private viewState: ViewStateService,
    private practitionerService: PractitionerService,
    private userService: UserService    
  ) {}

  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
    this.practitionerService
      .getMyDocumentsCertificates(this.personId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (details) => {
          this.documents = details;
        },
        (err) => {
          this.notifications.error(
            "Error getting files",
            "Unknown error getting files."
          );
          console.error(err);
          this.viewState.stopLoading();
        }
      );
  }

  getCandidateDocument(id: string, fileName: string, type: string) {
    this.practitionerService
      .getMyDocumentCertificate(id, this.personId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.downloadFile(res, parseInt(id, 10), fileName, type);
        },
        (error) => {
          console.error(error);
        }
      );
  }

  downloadFile(stream: any, _id: number, name: string, type: string) {
    const docApplicationType = this.getFriendlyApplicationType(type),
      blob = new Blob([stream], { type: docApplicationType });
    FileSaver.saveAs(blob, name);
  }

  getFriendlyApplicationType(type: string): string {
    switch (type) {
      case "PDF":
        return "application/pdf";
      case "DOC":
        return "application/msword";
      case "DOCX":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      default:
        return "";
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
